<script setup lang="ts">
import { classNames } from '@afinius/utilities/class-names';
import type { RouteLocationRaw } from 'vue-router';

import Clickable from '../Clickable/Clickable.vue';

interface Props {
  href?: string;
  to?: RouteLocationRaw;
  color?: 'error';
  spacing?: 'md' | 'lg';
  ariaLabel?: string;
  isDisabled?: boolean;
  isActive?: boolean;
  hasBorder?: boolean;
  shouldOpenBlank?: boolean;
  onClick?: () => void;
}

withDefaults(defineProps<Props>(), {
  href: undefined,
  to: undefined,
  color: undefined,
  spacing: 'md',
  ariaLabel: undefined,
  onClick: undefined,
});
</script>

<template>
  <div class="dropdown-action-wrapper">
    <Clickable
      class="dropdown-action"
      :class="classNames({ color, spacing, isDisabled, isActive, hasBorder })"
      :href="href"
      :to="to"
      :ariaLabel="ariaLabel"
      :isDisabled="isDisabled"
      :shouldOpenBlank="shouldOpenBlank"
      :onClick="onClick"
    >
      <slot />
    </Clickable>
  </div>
</template>

<style lang="scss">
@use './DropdownAction.scss';
</style>
